module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/icon_next-78297eba589c643a629fceacde083f3b.svg";